import axios from 'axios';
import React from 'react';

const calculatePrice = ({ products }) => {
  let totalPrice = 0;
  let discountedPrice = 0;

  products.forEach(product => {
    let productPrice = product.quantity * product.price;
    let productDiscountedPrice = product.quantity * product.discountedPrice;
    totalPrice = totalPrice + productPrice;
    discountedPrice = discountedPrice + productDiscountedPrice;
  });
  return { totalPrice, discountedPrice };
};

const formatPrice = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const renderSum = products => {
  const { totalPrice, discountedPrice } = calculatePrice(products);
  if (totalPrice !== discountedPrice) {
    return (
      <>
        <span style={{ fontSize: '14px', color: '#999', textDecoration: 'line-through', fontWeight: 400, marginRight: '6px' }}>
          {formatPrice(totalPrice)} грн
        </span>
        <strong style={{ fontWeight: 700 }}>{formatPrice(discountedPrice)} грн</strong>
      </>
    );
  }
  return <strong style={{ fontWeight: 700 }}>{formatPrice(totalPrice)} грн</strong>;
};

const saveReturnUrlBeforeLogin = () => {
  const url = window.location.pathname + window.location.search;
  if (!['/login', '/signup', '/restore-password'].includes(window.location.pathname)) {
    localStorage.setItem('currentUrl', url);
  }
};

const checkIsAdminLoggined = props => {
  const token = localStorage.getItem("token");
  if (!token) {
    saveReturnUrlBeforeLogin();
    props.history.push("/login");
    return;
  }
  axios
    .get("/api/v1/auth/current-user", {
      headers: {
        Authorization: token
      }
    })
    .then(res => {
      if (res.status === 200) {
        if (res.data.data.type !== "ADMIN") {
          saveReturnUrlBeforeLogin();
          props.history.push("/login");
        }
      }
    })
    .catch(reason => {
      saveReturnUrlBeforeLogin();
      props.history.push("/login");
    });
};

const checkIfUserIsLoggined = props => {
  const token = localStorage.getItem("token");
  if (!token) {
    saveReturnUrlBeforeLogin();
    props.history.push("/login");
    return;
  }
  axios
      .get("/api/v1/auth/current-user", {
        headers: {
          Authorization: token
        }
      })
      .then(res => {
        if (res.status !== 200) {
          saveReturnUrlBeforeLogin();
          props.history.push("/login");
        }
      })
      .catch(reason => {
        saveReturnUrlBeforeLogin();
        props.history.push("/login");
      });
};

const UKRAINIAN_MONTHS_GENITIVE = [
  'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
  'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'
];

/**
 * Конвертує дату з API (string YYYY-MM-DD або об'єкт {year, monthValue, dayOfMonth}) у значення для input type="date" (YYYY-MM-DD).
 */
export const toDateInputValue = (value) => {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value.split('T')[0];
  if (Array.isArray(value) && value.length >= 3) {
    const [y, m, d] = value;
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  }
  if (typeof value === 'object' && (value.year != null || value.monthValue != null || value.dayOfMonth != null)) {
    const y = value.year;
    const m = value.monthValue != null ? value.monthValue : (value.month != null ? value.month + 1 : 1);
    const d = value.dayOfMonth != null ? value.dayOfMonth : value.day;
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  }
  return '';
};

/**
 * Форматує дату надходження (YYYY-MM-DD або об'єкт) у "D місяць" (наприклад, "28 лютого", "15 березня").
 * Повертає null/undefined, якщо дата відсутня.
 */
export const formatExpectedArrivalDate = (value) => {
  if (value == null || value === '') return null;
  let dateStr = '';
  if (typeof value === 'string') {
    dateStr = value.split('T')[0];
  } else if (Array.isArray(value) && value.length >= 3) {
    const [y, m, d] = value;
    dateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  } else if (typeof value === 'object' && (value.year != null || value.monthValue != null || value.dayOfMonth != null)) {
    const y = value.year;
    const m = value.monthValue != null ? value.monthValue : (value.month != null ? value.month + 1 : 1);
    const d = value.dayOfMonth != null ? value.dayOfMonth : value.day;
    dateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  } else {
    return null;
  }
  const parts = dateStr.split('-');
  if (parts.length !== 3) return null;
  const [, m, d] = parts;
  const monthNum = parseInt(m, 10);
  const dayNum = parseInt(d, 10);
  if (monthNum < 1 || monthNum > 12 || isNaN(dayNum)) return null;
  const monthName = UKRAINIAN_MONTHS_GENITIVE[monthNum - 1];
  return `${dayNum} ${monthName}`;
};

/**
 * Форматує дату надходження у вигляді "D-го місяць" (наприклад, "28-го лютого") для бейджа.
 */
export const formatExpectedArrivalDateOrdinal = (value) => {
  const formatted = formatExpectedArrivalDate(value);
  if (!formatted) return null;
  return formatted.replace(/^(\d+)\s/, '$1-го ');
};

export const getAlmostSoldOutText = (n) => {
  if (n === 1) return 'Залишилась лише 1шт';
  if (n === 2) return 'Залишилось лише 2шт';
  if (n === 3) return 'Залишилось лише 3шт';
  return `Залишилось лише ${n}шт`;
};

export const getAlmostSoldOutTooltipText = (n) => {
  if (n === 1) return 'Останній екземпляр. Може закінчитись у будь-який момент';
  return 'Залишилось мало одиниць товару';
};

export { renderSum, calculatePrice, formatPrice, checkIsAdminLoggined, checkIfUserIsLoggined };

